import { FC } from "react";
import { AllieContentProps } from "./Content.types";
import { StyledContent } from "./Content.styles";

export const AllieContent: FC<AllieContentProps> = (props) => <StyledContent {...props} />;
